var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loadingCategories || !_vm.currentProduct
    ? _c("v-skeleton-loader", { attrs: { type: "actions" } })
    : _c(
        "div",
        [
          _c(
            "v-container",
            {
              staticClass: "text-center py-0 pl-0 pr-0 pb-0",
              attrs: { fluid: "" }
            },
            [
              _c("div", { staticClass: "text-center main-title" }, [
                _c("h1", [_vm._v(_vm._s(_vm.title))])
              ])
            ]
          ),
          _c(
            "v-container",
            { staticClass: "mt-3", attrs: { "grid-list-lg": "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c("v-flex", { attrs: { xs12: "", sm5: "" } }),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm7: "" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          staticClass: "navigation",
                          attrs: { flat: "", dense: "" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "pl-0",
                              attrs: { small: "", text: "" },
                              on: { click: _vm.backButton }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-chevron-left")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("product.backToCategory")) +
                                  " "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm5: "" } },
                    [
                      _vm.loadingCategories
                        ? _c("v-skeleton-loader", { attrs: { type: "image" } })
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "product-title-container" },
                        [
                          _c(
                            "v-img",
                            {
                              attrs: { src: _vm.getProductImage(_vm.imageData) }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "text-center",
                                  staticStyle: {
                                    width: "100%",
                                    "margin-top": "40%"
                                  }
                                },
                                [
                                  _c("h1", { staticClass: "white--text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("homepage.currency", {
                                          price: _vm.formatThousands(
                                            _vm.currentProduct.amountWithVat
                                          )
                                        })
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm7: "" } },
                    [_c("product-detail")],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-center mt-5 mb-5",
                      staticStyle: { color: "#ee2a7b" },
                      attrs: { cols: "12", md: "6" }
                    },
                    [
                      _c("h2", [
                        _vm._v(
                          "▼ " + _vm._s(_vm.$t("product.validHere")) + " ▼"
                        )
                      ]),
                      _c(
                        "v-container",
                        _vm._l(_vm.currentProduct.subItems, function(subItem) {
                          return _c(
                            "v-row",
                            { key: subItem.id },
                            [
                              _c(
                                "v-col",
                                { attrs: { xs: "12", sm: "2", md: "2" } },
                                [
                                  _c("v-img", {
                                    class: {
                                      half: _vm.$vuetify.breakpoint.xsOnly
                                    },
                                    attrs: { src: subItem.imageUrl }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { xs: "12", sm: "10", md: "10" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "mb-1 text-left" },
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            color: "primary",
                                            size: "x-small"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("product.includedInPrice")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "headline mb-1 text-left",
                                      staticStyle: { color: "#ee2a7b" }
                                    },
                                    [_vm._v(_vm._s(subItem.shortDescription))]
                                  ),
                                  _c("div", {
                                    staticClass: "text-left",
                                    staticStyle: { color: "#262262" },
                                    domProps: {
                                      innerHTML: _vm._s(subItem.description)
                                    }
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }